import { isBefore } from 'date-fns'
import { z } from 'zod/v4'
import { type OfferRecommendationFragment } from '@/services/graphql/generated'
import { convertToDate } from '@/utils/date'
import { CrossSellFieldKeys } from './CrossSell.constants'

export function getOfferNumberCoInsuredWithFallback(offer: OfferRecommendationFragment) {
  const CO_INSURED_DATA_KEY = 'numberCoInsured'

  return parseInt(offer.priceIntentData[CO_INSURED_DATA_KEY]) || 0
}

export function getOfferMileageWithFallback(offer: OfferRecommendationFragment) {
  return offer.priceIntentData[CrossSellFieldKeys.MILEAGE]
    ? String(offer.priceIntentData[CrossSellFieldKeys.MILEAGE])
    : undefined
}

export function getOfferStartDateWithFallback(offer: OfferRecommendationFragment) {
  const today = new Date()
  const offerStartDate = convertToDate(offer.startDate)
  if (offerStartDate === null || isBefore(offerStartDate, today)) return today

  return offerStartDate
}

const FORM_SCHEMA = z.object({
  [CrossSellFieldKeys.NUMBER_CO_INSURED]: z.string().transform((value) => parseInt(value, 10)),
  [CrossSellFieldKeys.START_DATE]: z.string().transform((value) => new Date(value)),
  [CrossSellFieldKeys.INTENT]: z.enum(['add-offer', 'update-price']),
})

type FormInput = {
  [CrossSellFieldKeys.NUMBER_CO_INSURED]: number
  [CrossSellFieldKeys.START_DATE]: Date
  [CrossSellFieldKeys.INTENT]: 'add-offer' | 'update-price'
}

export function getFormValues(formData: FormData): FormInput {
  const data = FORM_SCHEMA.parse(Object.fromEntries(formData.entries()))

  return data
}

export function hasNumberCoInsured(offer: OfferRecommendationFragment): boolean {
  const data = offer.priceIntentData ?? {}
  return CrossSellFieldKeys.NUMBER_CO_INSURED in data
}
